import React from 'react';
import EditorClearFormat from '@wix/da-ds/pkg/Icons/24x24/EditorClearFormat';
import { ButtonProps } from './types';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../_partials/EditorIconButton';

const ClearFormatting: React.FC<ButtonProps> = ({
  editor,
  hideWhenNotEnabled = true,
}) => {
  const { t } = useTranslation('editor');

  return (
    <EditorIconButton
      featureId="format:clear"
      icon={EditorClearFormat}
      onClick={() =>
        editor.chain().focus().unsetAllMarks().closeLinkBubbleMenu().run()
      }
      tooltipText={t('button.clearformat.tooltip')}
      aria-label={t('button.clearformat.tooltip')}
    />
  );
};
ClearFormatting.displayName = 'ClearFormatting';

export default ClearFormatting;
